import script from "./hire.vue?vue&type=script&setup=true&lang=js"
export * from "./hire.vue?vue&type=script&setup=true&lang=js"

import "./hire.vue?vue&type=style&index=0&id=79761d3d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79761d3d"]])

export default __exports__